// Safe Meta Pixel event wrapper. Never throws if fbq isn't loaded (ad blockers,
// preview without the pixel, etc.) so tracking can never break the app.
export function fbTrack(event, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", event, params);
    }
  } catch (err) {
    if (process.env.NODE_ENV === "development") console.debug("fbq skipped", err);
  }
}
